import React from "react";
import GoChapter from "../GoChapter";

export function PublicInfo() {
    return (
        <ul>
            <li>
                1.“仅上传暂不发布”是指上传的文档或视频是老师们在课中教学使用的。
            </li>
            <li>
                2.“上传并立即发布”是指上传的文档或视频文件需要学生在课前或课后学习的。
            </li>
        </ul>
    );
}

export function ChapterInfo() {
    return (
        <p>
            如果您需要将课程教学中使用的文件按章节目录结构整理，那可以通过点击
            <GoChapter />
            前往设置课程的章节目录，维护好课程的章节目录接口后在课件列表添加的本地文件、直播回放、网页链接等课件都会按章节目录结构展示。如果没有这个诉求，可以无视掉这个设置项。
        </p>
    );
}

export function NextInfo() {
    return (
        <p>
            维护好以上内容后，请点击“下一步”按钮，前往直播回放列表选取要添加的直播回放视频。
        </p>
    );
}

export function FileInfo(configFileList: String) {
    return (
        <ul>
            <li>1.支持批量上传文件，单个文件不能超 500M</li>
            <li>
                2.上传的文件名不能超过 200个字，且名称不能包含：\|/:?*&lt; &gt;
                或\0
            </li>
            <li>3.支持上传的文件格式为 {configFileList}</li>
            <li>4.如无法预览视频请使用最新版的谷歌浏览器</li>
            <li>
                5.禁止上传可执行文件，例如后缀为 exe
                的文件，建议打包后上传并设置该课件允许学生下载
            </li>
        </ul>
    );
}
